import { computed, makeObservable, observable } from "mobx";

import type { Dictionary } from "@noli/core";
import { ABCStore } from "@noli/business";

export interface IParametersStore {
  useLocalServer: boolean;
  localServerHost: string;
  useLocalModel: boolean;
  localModelVersion: string;
  localModelName: string;
  availableModelVersions: string[];
  availableModelNames: string[];
  localModelRoot: string;
  activatedLocalModels: Dictionary<string>;
  tokenRoot: string;
}
class ParametersStore extends ABCStore<IParametersStore> implements IParametersStore {
  useLocalServer = false;
  localServerHost = "http://localhost:8123";
  useLocalModel = false;
  localModelVersion = "";
  localModelName = "";
  availableModelNames: string[] = [];
  availableModelVersions: string[] = [];
  localModelRoot = "";
  activatedLocalModels: Dictionary<string> = {};
  tokenRoot = "";

  constructor() {
    super();
    makeObservable(this, {
      useLocalServer: observable,
      localServerHost: observable,
      useLocalModel: observable,
      localModelVersion: observable,
      localModelName: observable,
      availableModelNames: observable,
      availableModelVersions: observable,
      localModelRoot: observable,
      activatedLocalModels: observable,
      tokenRoot: observable,
      creatorHost: computed,
    });
  }

  get info(): IParametersStore {
    return this;
  }

  get creatorHost(): string {
    return this.useLocalServer
      ? this.localServerHost.trim().replace(/\/+$/, "")
      : this.creatorKafkaHost;
  }

  get creatorKafkaHost(): string {
    return `${process.env.REACT_APP_MAIN_URL}/ai_creator/engine`;
  }

  get creatorBatchKafkaHost(): string {
    return `${process.env.REACT_APP_MAIN_URL}/ai_creator`;
  }
}

export const parametersStore = new ParametersStore();
export const updateParameters = parametersStore.updateProperty.bind(parametersStore);
